import React, { forwardRef, useMemo } from 'react';

import { extend, useThree } from '@react-three/fiber';

import { EffectConstructor, EffectProps } from './types.js';

let i = 0;
const components = new WeakMap<EffectConstructor, React.ExoticComponent<any> | string>();

export const wrapEffect = <T extends EffectConstructor>(effect: T, defaults?: EffectProps<T>) =>
  forwardRef<T, EffectProps<T>>(
    ({ blendFunction = defaults?.blendFunction, opacity = defaults?.opacity, ...props }, ref) => {
      let Component = components.get(effect);
      if (!Component) {
        const key = `@react-three/postprocessing/${effect.name}-${i++}`;
        extend({ [key]: effect });
        components.set(effect, (Component = key));
      }

      const camera = useThree((state) => state.camera);
      const args = useMemo(
        () => [
          ...((defaults?.args ?? []) as any[]),
          ...((props.args ?? [{ ...defaults, ...props }]) as any[]),
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(props)]
      );

      return (
        <Component
          blendMode-blendFunction={blendFunction}
          blendMode-opacity-value={opacity}
          camera={camera}
          {...props}
          ref={ref}
          args={args}
        />
      );
    }
  );
